import { TextField as MuiTextField, TextFieldProps } from "@mui/material"

const TextField = ({ sx, ...rest }: TextFieldProps) => {
  return (
    <MuiTextField
      sx={{
        "& input": {
          borderRadius: 2,
          p: 1.5,
          bgcolor: "#EDEDED",
        },
        "& fieldset": {
          border: "none",
        },
        "& .MuiFormHelperText-root": {
          mt: 1,
          ml: 0,
          fontWeight: 500,
        },
        ...sx,
      }}
      {...rest}
    />
  )
}

export default TextField
